var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable no-undefined */
import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Input from '../BasicInput';
import useDebounce from '../../../hooks/useDebounce';
// Regex from https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/email
// eslint-disable-next-line no-useless-escape
var regex = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export var EmailInput = function (_a) {
    var error = _a.error, onError = _a.onError, onValid = _a.onValid, onChange = _a.onChange, value = _a.value, defaultValue = _a.defaultValue, props = __rest(_a, ["error", "onError", "onValid", "onChange", "value", "defaultValue"]);
    var _b = useState(true), isValid = _b[0], setIsValid = _b[1];
    var _c = useState(value || defaultValue || ''), email = _c[0], setEmail = _c[1];
    var debouncedEmail = useDebounce(email, 1000);
    useEffect(function () {
        if (debouncedEmail) {
            setIsValid(Boolean(debouncedEmail.match(regex)));
        }
        else {
            setIsValid(true);
        }
    }, [debouncedEmail]);
    useEffect(function () {
        if (isValid && onValid) {
            onValid();
        }
        else if (!isValid && onError) {
            onError();
        }
    }, [isValid, onError, onValid]);
    return (React.createElement(Input, __assign({}, props, { error: error ||
            (isValid ? undefined : (React.createElement(FormattedMessage, { defaultMessage: "Please correct your e-mail", id: "input.email.error" }))), onChange: function (event) {
            setEmail(event.target.value);
            if (onChange) {
                onChange(event);
            }
        }, type: "email", defaultValue: email })));
};
export default EmailInput;
//# sourceMappingURL=index.js.map